import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '@/components/hooks/use-toast';
import { selectQuotes, selectIllustration, markErrorToastAsShown } from '@client/model';

interface UseErrorToastsProps {
  open: boolean;
}

export function useErrorToasts({ open }: UseErrorToastsProps) {
  const dispatch = useDispatch();
  const { errorToast } = useToast();
  const quotes = useSelector(selectQuotes);
  const illustration = useSelector(selectIllustration);

  useEffect(() => {
    if (!open || !illustration.erroredRequests || !quotes) return;
    const currentQuoteIds = new Set(quotes.map(quote => quote.insuranceQuoteId));

    Object.entries(illustration.erroredRequests).forEach(([quoteId, errorInfo]) => {
      if (!currentQuoteIds.has(quoteId)) return;

      if (errorInfo.errors && errorInfo.errors.length > 0) {
        const errorMessage = errorInfo.errors[0];
        const errorKey = `${quoteId}-${errorInfo.errorDateTime?.getTime()}-${errorMessage}`;
        const hasShownToast = illustration.shownErrorToasts?.[errorKey] || false;

        if (!hasShownToast) {
          dispatch(markErrorToastAsShown(errorKey));

          errorToast(
            'Quote Generation Failed',
            React.createElement(
              React.Fragment,
              null,
              'We encountered an error while generating your quote. Please contact us at ',
              React.createElement(
                'a',
                {
                  href: 'mailto:hello@joinwaterlily.com',
                  className: 'text-white underline hover:no-underline'
                },
                'hello@joinwaterlily.com'
              ),
              ' and we\'ll help you.'
            ),
            10000,
          );
        }
      }
    });
  }, [
    open,
    illustration.erroredRequests,
    quotes,
    illustration.shownErrorToasts,
    dispatch,
    errorToast,
  ]);
}